import { Company } from "../models/company.model";
import { RequirementContent } from "../models/requirement.content.model";

export function percentageCalculate(total: number, amount: number): string {
  let percentage: number = (amount * 100) / total
  return `${percentage === 100 ? percentage : percentage.toFixed(2)}%`;
}

export function accumulatedAmountDocuments(documents: any[]): {subtotal: number, rebate: number, tax: number, total: number, paid: number, debt: number} {
  let amountSubtotal: number = 0
  let amountRebate: number = 0
  let amountTax: number = 0
  let amountTotal: number = 0
  let amountPaid: number = 0
  let amountDebt: number = 0

  for (let document of documents) {
    amountSubtotal += document.amount.sub_total
    amountRebate += document.amount.rebate_total
    amountTax += document.amount.tax_total
    amountTotal += document.amount.total

    if (document.amount.paid) { amountPaid += document.amount.paid }
    if (document.amount.debt) { amountDebt += document.amount.debt }
  }

  return {subtotal: amountSubtotal, rebate: amountRebate, tax: amountTax, total: amountTotal, paid: amountPaid, debt: amountDebt}
}

export function accumulatedDebitCreditDocuments(companyForUser: Company, content_accounts: {content: RequirementContent, accounting_account_debit: string, accounting_account_credit: string}[]): {net: number, gross: number, rebate: number, tax: number, debit: number, credit: number} {    
  let amountNet: number = 0
  let amountGross: number = 0
  let amountRebate: number = 0
  let amountTax: number = 0
  let amountDebit: number = 0
  let amountCredit: number = 0

  if (companyForUser.subject_tax) {
    if (companyForUser.vat_debt_method === 'invoicing'){
      if (companyForUser.tax_method === 'effective') {
        for (let content_account of content_accounts) {
          amountNet += content_account.content.price_net
          amountGross += (content_account.content.price_unit > 0) ? (content_account.content.price_net - content_account.content.tax_amount + content_account.content.rebate_amount) : 0
          amountRebate += (content_account.content.price_unit < 0) ? ((content_account.content.price_net - content_account.content.tax_amount) * -1) : content_account.content.rebate_amount
          amountTax += content_account.content.tax_amount
        }
      } else {
        for (let content_account of content_accounts) {
          amountNet += content_account.content.price_net
          amountGross += (content_account.content.price_unit > 0) ? (content_account.content.price_net - (content_account.content.price_net * Number(companyForUser.tax_rate) / 100) + content_account.content.rebate_amount) : 0
          amountRebate += (content_account.content.price_unit < 0) ? ((content_account.content.price_net - (content_account.content.price_net * Number(companyForUser.tax_rate) / 100)) * -1) : content_account.content.rebate_amount
          amountTax += (content_account.content.price_net * Number(companyForUser.tax_rate) / 100)
        }
      }
    }
    if (companyForUser.vat_debt_method === 'cashing'){
      if (companyForUser.tax_method === 'effective') {
        for (let content_account of content_accounts) {
          amountNet += content_account.content.price_net
          amountGross += (content_account.content.price_unit > 0) ? (content_account.content.price_net + content_account.content.rebate_amount) : 0
          amountRebate += (content_account.content.price_unit < 0) ? (content_account.content.price_net * -1) : content_account.content.rebate_amount
        }
      } else {
        for (let content_account of content_accounts) {
          amountNet += content_account.content.price_net
          amountGross += (content_account.content.price_unit > 0) ? (content_account.content.price_net + content_account.content.rebate_amount) : 0
          amountRebate += (content_account.content.price_unit < 0) ? (content_account.content.price_net * -1) : content_account.content.rebate_amount
        }
      }
    }
  } else {
    for (let content_account of content_accounts) {
      amountNet += content_account.content.price_net
      amountGross += (content_account.content.price_unit > 0) ? (content_account.content.price_net + content_account.content.rebate_amount) : 0
      amountRebate += (content_account.content.price_unit < 0) ? (content_account.content.price_net * -1) : content_account.content.rebate_amount
    }
  }

  amountDebit = Math.round((amountNet + amountRebate) * 100) / 100
  amountCredit = Math.round((amountGross + amountTax) * 100) / 100

  return {net: amountNet, gross: amountGross, rebate: amountRebate, tax: amountTax, debit: amountDebit, credit: amountCredit}
}